import { render, staticRenderFns } from "./ReducedDeferredLisapay.vue?vue&type=template&id=76fd7736&scoped=true&"
import script from "./ReducedDeferredLisapay.vue?vue&type=script&lang=js&"
export * from "./ReducedDeferredLisapay.vue?vue&type=script&lang=js&"
import style0 from "./ReducedDeferredLisapay.vue?vue&type=style&index=0&id=76fd7736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd7736",
  null
  
)

export default component.exports